<template>
  <div class="ridership-interval-toggle d-flex align-items-center gap-2">
    <span class="rd-interval-label">{{ $t('flexigo.ridership.interval') }}</span>
    <toggle-button-group :options="intervalOptions" @change="handleChange" />
  </div>
</template>

<script>
import toggleButtonGroup from '../../../toggleButton/toggleButtonGroup.vue';

export default {
  name: 'RidershipIntervalToggle',
  components: { toggleButtonGroup },
  props: {
    selectedInterval: {
      type: String,
      default: '30min',
    },
  },
  computed: {
    intervals() {
      return [
        { value: '15min', label: this.$t('flexigo.ridership.interval15Min') },
        { value: '30min', label: this.$t('flexigo.ridership.interval30Min') },
        { value: '1hour', label: this.$t('flexigo.ridership.interval1Hour') },
      ];
    },
    intervalOptions() {
      return this.intervals.map(({ label, value }) => ({
        label,
        selected: value === this.selectedInterval,
      }));
    },
  },
  methods: {
    handleChange({ index }) {
      this.$emit('change', this.intervals[index].value);
    },
  },
};
</script>

<style scoped>
.rd-interval-label {
  font-size: 14px;
  color: #687692;
  font-weight: 500;
}
</style>
